import { createAsyncThunk } from "@reduxjs/toolkit";
import { getGeozoneObjects } from "domain/geozones/api/get-geozone-objects";

export const getGeozoneObjectsAction = createAsyncThunk(
  "geozones/getGeozoneObjectsAction",
  async ({
    accountId,
    geozoneId
  }: {
    accountId: string;
    geozoneId: string;
  }) => {
    try {
      return await getGeozoneObjects({ accountId, geozoneId });
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);
